import memoize from 'lodash/memoize';
import { track, trackAutoEvent } from '../../vendor/splitmetrics-track';



export const EVENT_NAME = 'in_app_view';


export default memoize((index = 0, auto = false) => {
  const props = { in_app_index: Number(index), in_app_id: index };

  if (auto) {
    trackAutoEvent(EVENT_NAME, props);
  } else {
    track(EVENT_NAME, props);
  }
}, (...args) => args.join(','));



// WEBPACK FOOTER //
// ./src/lib/track-event/in-app-view.js